module.exports = __webpack_public_path__ + "static/img/ind1.bb2f19d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/indicadores/ind1.png
// module id = b9tb
// module chunks = 3